import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button } from '../../../../../components/ui/Button';
import { Modal } from '../../../../../components/ui/Modal';
import { Field, inputClass } from '../../../../../components/ui/Field';
import { handOverAtPickupPoint } from '../../../../../features/orderDetails/orderDetailsThunks';

const HandOverDialog = ({ onClose, order }) => {
  const dispatch = useDispatch();
  const delivery = order.delivery;
  const [receivedBy, setReceivedBy] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const handleConfirm = async () => {
    setSaving(true);
    setError(null);
    const action = await dispatch(
      handOverAtPickupPoint({ orderId: order.id, deliveryId: delivery.id, receivedBy: receivedBy.trim() })
    );
    setSaving(false);
    if (action.meta.requestStatus === 'fulfilled') onClose();
    else setError(action.payload);
  };

  return (
    <Modal
      isOpen
      onClose={onClose}
      title="Confirmar entrega al cliente"
      size="sm"
      busy={saving}
      error={error}
      errorTitle="No se pudo registrar la entrega"
      testId="hand-over-modal"
    >
      <div className="space-y-5">
        <p className="text-sm text-text-secondary">
          El punto de retiro <b>{delivery?.pickup_point?.pickup_point_name}</b> entregó el pedido al
          cliente. El envío pasa a <b>Entregado</b> y no se puede deshacer.
        </p>
        <Field label="Quién lo recibió" htmlFor="hand-over-received-by" hint="Opcional. Nombre o RUT.">
          <input
            id="hand-over-received-by"
            className={inputClass}
            value={receivedBy}
            onChange={(e) => setReceivedBy(e.target.value)}
            placeholder="Ej: María Pérez, 12.345.678-9"
          />
        </Field>
        <div className="flex items-center justify-end gap-3">
          <Button variant="subtle" pill onClick={onClose} disabled={saving}>
            Cancelar
          </Button>
          <Button
            variant="primary"
            pill
            onClick={handleConfirm}
            loading={saving}
            loadingLabel="Registrando..."
          >
            Marcar como entregado
          </Button>
        </div>
      </div>
    </Modal>
  );
};

/**
 * The pickup point handed the parcel to the end customer: the one step that
 * closes a shipment redirected to a point. Also reachable from the CodeREADR
 * scanner; this is the OMS way.
 *
 * @param {object} props
 * @param {boolean} props.isOpen
 * @param {() => void} props.onClose
 * @param {object} props.order
 */
const HandOverModal = (props) => (props.isOpen ? <HandOverDialog {...props} /> : null);

export default HandOverModal;
